import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  FabButtonContainer,
  ScrollView,
} from "@inductiveautomation/ws-components";

import AccountAppBar from "../../components/AccountAppBar/AccountAppBar";
import LicensesDataGrid from "./Licenses.DataGrid";
import GetLicenseDialog from "./dialogs/GetLicenseDialog";
import GenerateActivationTokenDialog from "./dialogs/GenerateActivationTokenDialog";
import DeleteDialog from "./dialogs/DeleteDialog";
import { MakerLicenseAction } from "./Licenses.types";
import { getLicensesStyles } from "./_licenses.styles";
import {
  useGetMakerLicensesQuery,
  MakerLicenseSummaryItem,
} from "./api/makerLicenses.api";
import { MAX_MAKER_LICENSES_COUNT } from "./Licenses.data";

const Licenses = () => {
  const { data: apiData, isLoading } = useGetMakerLicensesQuery();

  const { t } = useTranslation();
  const { classes } = getLicensesStyles();
  const [activeDialog, setActiveDialog] = useState<
    MakerLicenseAction | undefined
  >();
  const [activeLicenses, setActiveLicenses] = useState<
    MakerLicenseSummaryItem[]
  >([]);

  const onAction = (actionId: string, licenseIds: string[]) => {
    setActiveDialog(actionId as MakerLicenseAction);

    const licenses = apiData?.licenses.filter((license) =>
      licenseIds.includes(license.key)
    );
    setActiveLicenses(licenses ?? []);
  };

  const closeDialog = () => setActiveDialog(undefined);
  return (
    !isLoading && (
      <div className={classes.page}>
        <AccountAppBar
          title={[
            {
              label: t("maker_licenses.title"),
              id: "account-app-bar-maker-licenses",
              onClick: () => undefined,
            },
          ]}
        />
        <ScrollView className={classes.scrollContainer}>
          <div className={classes.container}>
            <LicensesDataGrid
              licenses={apiData?.licenses ?? []}
              onAction={onAction}
            />
          </div>
        </ScrollView>

        {(apiData?.licenses ?? []).length < MAX_MAKER_LICENSES_COUNT && (
          <>
            <FabButtonContainer
              label={t("maker_licenses.actions.get_license.label")}
              icon="license-new"
              onClick={() => setActiveDialog("get-license")}
            />
            <GetLicenseDialog
              open={activeDialog === "get-license"}
              onClose={closeDialog}
              onSubmit={closeDialog}
            />
          </>
        )}

        <GenerateActivationTokenDialog
          open={activeDialog === "generate-activation-token"}
          licenses={activeLicenses}
          onClose={closeDialog}
          onSubmit={closeDialog}
        />
        <DeleteDialog
          open={activeDialog === "delete"}
          licenses={activeLicenses}
          onClose={closeDialog}
          onSubmit={closeDialog}
        />
      </div>
    )
  );
};

export default Licenses;
